import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import Logo from "@/components/common/Logo";
import { useAuth } from "@/lib/auth";
import { BRAND } from "@/branding.config";

const LINKS = [
  { to: "/pricing",    label: "Pricing",        tid: "nav-pricing" },
  { to: "/features",   label: "Features",       tid: "nav-features" },
  { to: "/locations",  label: "Locations",      tid: "nav-locations" },
  { to: "/enterprise", label: "Enterprise",     tid: "nav-enterprise" },
  { to: "/partners",   label: "Partners",       tid: "nav-partners" },
  { to: "/kb",         label: "Docs",           tid: "nav-kb" },
  { to: "/contact",    label: "Contact",        tid: "nav-contact" },
];

export default function PublicNavbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const loc = useLocation();
  const portalHref = user?.role === "admin" ? "/admin" : "/portal";
  void loc;

  return (
    <header className="sticky top-0 z-50 glass-nav">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <div className="flex items-center gap-10">
          <Logo />
          <nav className="hidden lg:flex items-center gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.tid}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-full text-sm transition-colors ${
                    isActive ? "text-foreground bg-white/[0.06]" : "text-muted-foreground hover:text-foreground"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="hidden lg:flex items-center gap-2">
          {user ? (
            <Link to={portalHref} data-testid="nav-portal-link" className="btn-outline">
              Open {user.role === "admin" ? BRAND.product_labels.admin : BRAND.product_labels.portal}
            </Link>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="btn-ghost text-sm">Sign in</Link>
              <Link to="/register" data-testid="nav-register" className="btn-primary text-sm">Get started</Link>
            </>
          )}
        </div>
        <button
          className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/[0.06] px-6 py-4 space-y-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block px-3 py-2 rounded-lg text-sm hover:bg-white/[0.04]"
            >
              {l.label}
            </Link>
          ))}
          <div className="pt-3 flex gap-2">
            {user ? (
              <Link to={portalHref} className="btn-primary flex-1">Open portal</Link>
            ) : (
              <>
                <Link to="/login"    className="btn-outline flex-1" data-testid="m-nav-login">Sign in</Link>
                <Link to="/register" className="btn-primary flex-1" data-testid="m-nav-register">Get started</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
